import { Component, OnInit } from '@angular/core';
import {
  SlokaTypeModel,
  AddSlokaTypeModel,
  AddSlokaModel,
  SlokaTypeBackendModel,
} from '../../interfaces/interfaces';
import { PassDataService } from '../../services/pass-data.service';
import { SlokaLogicService } from '../../logic/sloka.service';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { DashboardLogicService } from '../../logic/dashboard.service';

@Component({
  selector: 'add-sloka-pg',
  templateUrl: './add-sloka.component.html',
})
export class AddSlokaPage implements OnInit {
  slokaTypesList$: Observable<SlokaTypeModel[]> = new Observable<
    SlokaTypeModel[]
  >();
  isEnglish: boolean = true;
  isSanskrit: boolean = false;
  isBoth: boolean = false;
  slokaList: SlokaTypeModel[] = [];
  title: string = '';
  slokaTypeId: string = '';
  synopsis: string = '';
  videoLink: string = '';
  audioLink: string = '';
  pdfLink: string = '';
  audioFile: any = null;
  pdfFile: any = null;
  english: string = '';
  sanskrit: string = '';
  both: string = '';
  state: any = '';
  id: string = '';
  isUploadAudio: boolean = true;
  isUploadPdf: boolean = true;

  constructor(
    private passDataService: PassDataService,
    private slokaLogicService: SlokaLogicService,
    private dashboardLogicService: DashboardLogicService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.slokaTypesList$ = this.passDataService.getAllSlokaTypes();
    this.state = window.history.state;
    if (this.state.data) {
      if (this.state.isView) {
        this.isUploadAudio = false;
        this.isUploadPdf = false;
      }

      if ((this.state.isEdit && !this.state.isAddSloka) || this.state.isView) {
        this.title = this.state.data.title;
        this.slokaTypesList$.subscribe((l) => {
          let slokaType = l.filter((s) => s.id == this.state.data.slokaTypeId);
          this.slokaTypeId = slokaType[0].id;
        });
        this.synopsis = this.state.data.synopsis;
        this.videoLink = this.state.data.videoLink;
        this.audioLink = this.state.data.audioLink;
        this.pdfLink = this.state.data.pdfLink;
        this.english = this.state.data.english;
        this.sanskrit = this.state.data.sanskrit;
        this.both = this.state.data.both;
      }

      this.state.isAddSloka && (this.slokaTypeId = this.state.data.id);
    }
  }

  onRadioButtonChange(e: any) {
    const value = e.target.id;

    switch (value) {
      case 'english':
        this.isEnglish = true;
        this.isSanskrit = false;
        this.isBoth = false;
        break;
      case 'sanskrit':
        this.isEnglish = false;
        this.isSanskrit = true;
        this.isBoth = false;
        break;
      case 'both':
        this.isEnglish = false;
        this.isSanskrit = false;
        this.isBoth = true;
        break;
      default:
        this.isEnglish = true;
        this.isSanskrit = false;
        this.isBoth = false;
        break;
    }
  }

  setTitle(title: string) {
    this.title = title;
  }

  setSlokaTypeId(slokaType: SlokaTypeModel) {
    this.slokaTypeId = slokaType.id;
  }

  setSynopsis(synopsis: string) {
    this.synopsis = synopsis;
  }

  setVideoLink(videoLink: string) {
    this.videoLink = videoLink;
  }

  setAudioFile(file: any) {
    this.audioFile = file;
  }

  setPdfFile(file: any) {
    this.pdfFile = file;
  }

  setEnglishContent(english: string) {
    this.english = english;
  }

  setSanskritContent(sanskrit: string) {
    this.sanskrit = sanskrit;
  }

  setBothContent(both: string) {
    this.both = both;
  }

  onAddClick() {
    //if (
    //  this.title == '' &&
    //  this.synopsis == '' &&
    //  this.videoLink == '' &&
    //  this.audioFile == null &&
    //  this.pdfFile == null &&
    //  (this.english || this.sanskrit || this.both)
    //)
    //  return;

    this.passDataService.setPopup({
      isPopup: true,
      message: '',
      isOk: false,
      isDelete: false,
      isLoading: true,
      loadingMessage: 'Adding sloka, please wait!',
    });

    this.slokaLogicService
      .addSlokaLogic(
        this.title,
        this.slokaTypeId,
        this.synopsis,
        this.videoLink,
        this.audioFile != null ? this.audioFile.item(0) : null,
        this.pdfFile != null ? this.pdfFile.item(0) : null,
        this.english,
        this.sanskrit,
        this.both
      )
      .subscribe((v: any) => {
        this.router.navigate(['/page/slokas-list']);
        this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe();

        this.passDataService.setPopup({
          isPopup: true,
          message: v.message,
          isOk: true,
          isDelete: false,
          isLoading: false,
          loadingMessage: '',
        });
      });
  }

  onUpdateClick() {
    if (
      this.title == '' &&
      this.synopsis == '' &&
      this.videoLink == '' &&
      (this.english == '' || this.sanskrit == '' || this.both == '')
    )
      return;

    this.passDataService.setPopup({
      isPopup: true,
      message: '',
      isOk: false,
      isDelete: false,
      isLoading: true,
      loadingMessage: 'Updating sloka, please wait!',
    });

    this.slokaLogicService
      .updateSlokaLogic(
        this.title,
        this.slokaTypeId,
        this.synopsis,
        this.videoLink,
        this.audioFile != null ? this.audioFile.item(0) : null,
        this.state.data.audioLink,
        this.pdfFile != null ? this.pdfFile.item(0) : null,
        this.state.data.pdfLink,
        this.english,
        this.sanskrit,
        this.both,
        this.state.data._id
      )
      .subscribe((v: any) => {
        this.router.navigate(['/page/slokas-list']);
        this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe();

        this.passDataService.setPopup({
          isPopup: true,
          message: v.message,
          isOk: true,
          isDelete: false,
          isLoading: false,
          loadingMessage: '',
        });
      });
  }
  onEditClick() {
    this.state.isEdit = !this.state.isEdit;
    this.state.isView = !this.state.isView;
  }

  onVideoLinkClick() {
    this.state.isView && this.openLink(this.videoLink);
  }

  onAudioLinkClick() {
    this.state.isView && this.openLink(this.audioLink);
  }

  onPdfLinkClick() {
    this.state.isView && this.openLink(this.pdfLink);
  }

  openLink(link: string) {
    if (link) {
      const win = window.open(link, '_blank');
      if (win != null) {
        win.focus();
      }
    }
  }
}
